/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useState} from 'react';
import {Button} from "antd";
import {useStore} from "zustand";
import styles from './SystemGeoSetupRun.module.scss';
import PageTitle from "../../components/common/PageTitle/PageTitle";
import {useMessageStore} from "../../stores/messageStore";
import apiClient from "../../api/apiClient";

const DEV_BUCKET_URL = 'https://console.cloud.google.com/storage/browser/dispatcher-platform-dev;tab=objects?forceOnBucketsSortingFiltering=true&project=rb-basecamp&prefix=&forceOnObjectsSortingFiltering=false';
const PROD_BUCKET_URL = 'https://console.cloud.google.com/storage/browser/dispatcher-platform-prod;tab=objects?forceOnBucketsSortingFiltering=true&project=dispatcher-platform-production&prefix=&forceOnObjectsSortingFiltering=false';

const SystemGeoSetupRun = () => {
	const { setMessages } = useStore(useMessageStore);
	const [data, setData] = useState([]);

	const onUpload = async () => {
		try {
			const res = await apiClient.get('/api/admin/system/geo/setup');
			if (res.data.success) {
				setMessages('success', '완료');
			}
		} catch (e: any) {
			setMessages('error', e?.response?.data?.message || '에러 발생');
			console.log('ERROR: SystemGeoSetupRun');
			console.error(e);
		}
	};

	const onCheck = async () => {
		try {
			const res = await apiClient.get('/api/admin/system/geo/check');
			setData(res.data);
		} catch (e: any) {
			setMessages('error', e?.response?.data?.message || '에러 발생');
			console.log('ERROR: SystemGeoSetupRun');
			console.error(e);
		}
	};

	return (
		<div className={styles.wrap}>
			<div>
				<PageTitle title="시군 주소 레디스에 업로드"/>
			</div>
			<div
				className={styles.runButtonWrap}
			>
				<p>1. public bucket에 파일 잘 있나 확인</p>
				<p>(버킷)/address/si_gun.csv</p>
				<p><a href={DEV_BUCKET_URL} target="_blank" rel="noreferrer">DEV 버킷</a></p>
				<p><a href={PROD_BUCKET_URL} target="_blank" rel="noreferrer">PROD 버킷</a></p>
				<p>2. 업로드 실행</p>
				<Button onClick={onUpload}>업로드 실행</Button>
				<p>3. 업로드 확인</p>
				<Button onClick={onCheck}>업로드 확인</Button>
				{data.length > 0 && data.map((item) => <div>{item}</div>)}
			</div>
		</div>
	);
};

export default SystemGeoSetupRun;
